const { _CONFIG: configEnvVars = {} } = window;

/**
* WARNING: It's important to keep this file export as it is now, JSDocs help us with intellisense.
*  Also, if you want to add a new environment variable, please add it to the JSDocs below as well.
*/

/**
 * @typedef {Object} Configuration
 * @property {string} REACT_APP_ADMIN_PLATFORM_URI - The URI for the admin platform.
 * @property {string} REACT_APP_BROWSER_EXTENSION_VERSION_URI - The URI for the browser extension version.
 * @property {string} REACT_APP_COMPANY_PLATFORM_URI - The URI for the company platform.
 * @property {boolean} REACT_APP_ENABLE_SENTRY - Flag to enable Sentry.
 * @property {boolean} REACT_APP_ENABLE_SESSION_STACK - Flag to enable Session Stack.
 * @property {string} REACT_APP_FROALA_CODOX_API_KEY - The API key for Froala Codox.
 * @property {string} REACT_APP_FROALA_KEY - The key for Froala.
 * @property {string} REACT_APP_GOOGLE_TRIALS_TOKEN - The token for Google Trials.
 * @property {string} REACT_APP_HELP_PLAYBOOK_URL - The URL for the help playbook.
 * @property {string} REACT_APP_INTERCOM_APP_ID - The ID for Intercom app.
 * @property {string} REACT_APP_LINKEDIN_CLIENT_ID - The client ID for LinkedIn.
 * @property {string} REACT_APP_LINKEDIN_REDIRECT_URI - The redirect URI for LinkedIn.
 * @property {string} REACT_APP_LINKEDIN_SCOPE - The scope for LinkedIn.
 * @property {string} REACT_APP_MAC_URL_DOWNLOAD - The URL for downloading on Mac.
 * @property {string} REACT_APP_PLATFORM_TYPE - The type of platform.
 * @property {string} REACT_APP_PLATFORM_URI - The URI for the platform.
 * @property {string} REACT_APP_PLAYBOOKUX_API_URI - The URI for PlaybookUX API.
 * @property {string} REACT_APP_PLAYBOOKUX_GRAPHQL_PUBLIC_URI - The URI for PlaybookUX public GraphQL.
 * @property {string} REACT_APP_PLAYBOOKUX_GRAPHQL_TESTER_URI - The URI for PlaybookUX tester GraphQL.
 * @property {string} REACT_APP_PLAYBOOKUX_LIVESTREAM_GRAPHQL_URI - The URI for PlaybookUX livestream GraphQL.
 * @property {string} REACT_APP_PLAYBOOKUX_GRAPHQL_URI - The URI for PlaybookUX GraphQL.
 * @property {string} REACT_APP_PLAYBOOKUX_SHARE_GRAPHQL_URI - The URI for PlaybookUX share GraphQL.
 * @property {string} REACT_APP_SENTRY_ENVIRONMENT - The environment for Sentry.
 * @property {string} REACT_APP_SENTRY_URL - The URL for Sentry.
 * @property {boolean} REACT_APP_SHOW_STYLE_GUIDE - Flag to show style guide.
 * @property {string} REACT_APP_ZOOM_API_KEY - The API key for Zoom.
 * @property {string} REACT_APP_TESTER_PLATFORM_URI - The URI for the tester platform.
 * @property {string} REACT_APP_WINDOWS_MS_STORE_URL - The URL for downloading on Windows from Microsoft Store.
 * @property {string} REACT_APP_WINDOWS_URL_DOWNLOAD - The URL for downloading on Windows.
 * @property {string} REACT_APP_ZOOM_VIDEO_SDK_KEY - The video SDK key for Zoom.
 * @property {string} REACT_APP_ZOOM_VIDEO_SDK_SECRET - The video SDK secret for Zoom.
 * @property {number} REACT_APP_SENTRY_SAMPLE_RATE_COMPANY - The sample rate for Sentry in company environment.
 * @property {number} REACT_APP_SENTRY_SAMPLE_RATE_TESTER - The sample rate for Sentry in tester environment.
 * @property {number} REACT_APP_SENTRY_SAMPLE_RATE_ADMIN - The sample rate for Sentry in admin environment.
 * @property {number} REACT_APP_SENTRY_SAMPLE_RATE_DEFAULT - The default sample rate for Sentry.
 * @property {boolean} REACT_APP_RECAPTCHA_ENABLED - Flag to enable reCAPTCHA.
 * @property {string} REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY - The site key for Google reCAPTCHA.
 * @property {string} REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY_V2 - The site key for Google reCAPTCHA v2.
 * @property {string} REACT_APP_LIVESTREAM_SOCKET_URL - The URL for livestream socket.
 * @property {string} REACT_APP_IP_INFO_KEY - The IP info key.
 * @property {string} REACT_APP_PRACTICE_TEST_PROJECT_ID - The project ID for practice test.
 * @property {string} REACT_APP_PRACTICE_TEST_SEGMENT_ID - The segment ID for practice test.
 * @property {string} REACT_APP_PLAYBOOKUX_API_WEBSOCKET - The URI of Websocket API.
 */

/**
 * @type {Configuration}
 */
const config = {
  ...configEnvVars,
  REACT_APP_PLATFORM_TYPE: process.env.REACT_APP_PLATFORM_TYPE || configEnvVars.REACT_APP_PLATFORM_TYPE,
};
export { config };
